const roles = {
  administrator: "Administrador",
  recruiter: "Recrutador",
  personal_department: "Departamento Pessoal",
  supervisor: "Supervisor de Estágio",
  representative: "Representante Legal",
  hr_business_partner: "HR Business Partner",
  financial: "Financeiro",
};

export default roles;